import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent }  from './layouts/simple-layout.component';
import { AuthGuard } from './_guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        data : {
          roles : ['COLABORADOR','INSCRIBIR','JEFE','GERENTE_SUCURSAL']
        }
      },
      {
        path: 'proyectos',
        canActivate: [AuthGuard],
        loadChildren: './proyectos/proyectos.module#ProyectosModule',
        data : {
          roles : ['JEFE']
        }
      },
      {
        path: 'crm',
        loadChildren: './crm/crm.module#CrmModule'
      }
    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
      }
    ]
  },
  { path: '**', redirectTo: 'pages' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts